import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { logoIcons } from '../components/sb-company-logo/sb-company-logo.component';
import { Acct } from '../state/accts/acct.model';
import { AcctsQuery } from '../state/accts/accts.query';
import { AccountIssuersQuery } from '../../pages/admin/state/account-issuers/account-issuers.query';
import { combineQueries } from '@datorama/akita';
import { AccountIssuer } from '../../pages/admin/state/account-issuers/account-issuer.model';

@Pipe({
    name: 'accountLogo$',
    standalone: true
})
export class AccountLogoPipe implements PipeTransform {
    constructor(
        private _accountsQuery: AcctsQuery,
        private _issuersQuery: AccountIssuersQuery
    ) {}

    transform(
        accountId: Acct['accountId'],
        issuerId?: AccountIssuer['accountIssuerId']
    ): Observable<{
        logoUrl: string;
        website: string;
        icon: logoIcons;
        countryCode: string;
    }> {
        return combineQueries([
            this._accountsQuery.selectById$(accountId),
            this._issuersQuery.allAsObject$
        ]).pipe(
            map(([account, issuersMap]) => {
                let icon: logoIcons = 'BRIEFCASE';
                const issuer = issuersMap[issuerId || account?.accountIssuerId];
                const thumbnail = {
                    logoUrl: issuer?.metadata?.logoUrl,
                    website: issuer?.metadata?.website,
                    icon,
                    countryCode: null
                };
                switch (account?.accountType) {
                    // TODO: add more account types
                    default:
                        return {
                            ...thumbnail,
                            icon
                        };
                }
            })
        );
    }
}
